module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Black Ghosts")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgment"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#part-1"
    }
  }, [_vm._v("Part 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#the-first-step"
    }
  }, [_vm._v("The First Step")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0003#a-book-and-a-rice-bowl"
    }
  }, [_vm._v("A Book and a Rice Bowl")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0004#white-card"
    }
  }, [_vm._v("White Card")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0005#ill-go-with-you"
    }
  }, [_vm._v("I’ll Go With You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0006#lai-ying"
    }
  }, [_vm._v("Lai Ying")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0007#my-silly-egg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Silly Egg")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#wangs-den",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wang’s Den")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#a-rose-is-for-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rose Is for Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0010#chants-sticks-and-banners",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chants, Sticks, and Banners")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#trojan-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trojan Girl")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0012#peoples-sanctuary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People’s Sanctuary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#a-good-student",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Student")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0014#from-the-sidelines",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Sidelines")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#part-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0015#kowloon-promenade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kowloon Promenade")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0016#chacha",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chacha")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0017#chicken-treatment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Treatment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0018#so-long-time-no-see",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Long Time No See")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#pipe-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pipe Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0020#give-us-a-break-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give Us a Break, Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0021#unfinished-business",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unfinished Business")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#what-were-you-thinking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Were You Thinking?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#we-make-the-plan-okay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Make the Plan, Okay?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0024#the-family-is-everything",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Family Is Everything")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0025#take-a-chance-eggman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take a Chance, Eggman")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#part-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0026#this-is-the-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Is the Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0027#buffer-zone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buffer Zone")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0028#true-gweilos",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Gweilos")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0029#a-new-beginning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Beginning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0030#this-is-trespass",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Is Trespass")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0031#ill-be-ready-for-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’ll Be Ready for You")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#part-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0032#so-long-a-wait",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Long a Wait")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0033#a-pretty-tight-deal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pretty Tight Deal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0034#dumb-tour-agent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Tour Agent")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0035#the-fourth-chimurenga",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Chimurenga")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0036#im-all-ears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m All Ears")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0